import Dexie, { type Table } from 'dexie';

export interface OfflineAction {
  id?: number;
  type: string; // 'createCommande', 'updateStatus', etc.
  params: any;
  timestamp: number;
}

export class AtelierDatabase extends Dexie {
  // Tables
  commandes!: Table<any>;
  clients!: Table<any>;
  stocks!: Table<any>;
  personnel!: Table<any>;
  actionsQueue!: Table<OfflineAction>; // Actions à synchroniser

  constructor() {
    super('AtelierBassoumDB');
    this.version(1).stores({
      commandes: 'id, status, date_commande',
      clients: 'id, nom',
      stocks: 'id, nom',
      personnel: 'id, nom',
      actionsQueue: '++id, type, timestamp'
    });
  }
}

export const db = new AtelierDatabase();
